var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompareMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,33H22.4140625l8.2929688-8.2929688l-1.4140625-1.4140625L21,31.5859375C20.3554688,32.2304688,20,33.0878906,20,34 s0.3554688,1.7695312,1,2.4140625l8.2929688,8.2929688l1.4140625-1.4140625L22.4140625,35H48V33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,14c0-0.9121094-0.3554688-1.7695312-1-2.4140625l-8.2929688-8.2929688l-1.4140625,1.4140625L25.5859375,13H0v2 h25.5859375l-8.2929688,8.2929688l1.4140625,1.4140625L27,16.4140625C27.6445312,15.7695312,28,14.9121094,28,14z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompareMedium);
export default __webpack_public_path__ + "static/media/compare--medium.2dff6e9ab3bd7fe3c266838e70c4c68a.svg";
export { ForwardRef as ReactComponent };